module.exports = __webpack_public_path__ + "static/media/LP-application-left.00198bbc.png";